import { mapActions } from "vuex";
import BaseForm from "@/components/BaseForm";
import Agreement from "../view/user/components/Agreement.vue";
const mixinRegistered = {
  components: {
    BaseForm,
    Agreement
  },
  methods: {
    ...mapActions(["PhoneReg"]),
    /**
     * @description 密码与账号对比提示
     */
    showToast(msg) {
      this.$refs.form.disabled = false;
      this.$Toast(msg || "密码不能与账号相同");
    },
    /**
     * @description 设置表单按钮
     * @param {boolean} val  - 按钮disabled
     */
    setFormDisabled(val) {
      this.$refs.form.disabled = !val;
    },
    /**
     * @description 手机注册
     * @param {object} parmas  - 参数
     * @param {number} parmas  - 类型
     */
    doPhone(parmas, type) {
      this.PhoneReg(parmas)
        .then(res => {
          if (res.rcode == 0) {
            this.$router.replace({
              path: this._anchor.profile.path
            });
          }
          if (type == "registered" && res.rcode == 6002) {
            let timer;
            clearTimeout(timer);
            timer = setTimeout(() => {
              this.$router.replace({
                path: this._anchor.login.path,
                query: {
                  phone: this.iconPhone
                }
              });
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.form.disabled = false;
        })
        .finally(() => {
          if (this.$refs.form) {
            this.$refs.form.disabled = false;
          }
        });
    }
  }
};
export { mixinRegistered };
